var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUruguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0038A8",
    d: "M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-1H0v1zm0-8h36v4H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M0 23h36v3H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0038A8",
    d: "M36 9a4 4 0 0 0-4-4H16v4h20zm-20 3h20v4H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M16 9V5H4a4 4 0 0 0-4 4v10h36v-3H16v-4h20V9H16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD983",
    d: "M13 12a5 5 0 1 0-10 0a5 5 0 0 0 10 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    d: "M12 12a4 4 0 1 0-8 0a4 4 0 0 0 8 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M8 5.597l.633 4.041l2.569-3.183l-1.473 3.816l3.816-1.473l-3.183 2.569l4.041.633l-4.041.633l3.183 2.569l-3.816-1.473l1.473 3.816l-2.569-3.183L8 18.403l-.633-4.041l-2.569 3.183l1.473-3.816l-3.816 1.473l3.183-2.569L1.597 12l4.041-.633l-3.183-2.569l3.816 1.473l-1.473-3.816l2.569 3.183z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M11 12a3 3 0 1 0-6 0a3 3 0 0 0 6 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M5.834 12.004a2.153 2.153 0 1 1 4.307-.001a2.153 2.153 0 0 1-4.307.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUruguay);
export default __webpack_public_path__ + "static/media/flag-uruguay.648eb10a76ccfeec4782036c3ee10036.svg";
export { ForwardRef as ReactComponent };